// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container {\n  padding: 10px 20px;\n}\n.headerTitle {\n  font-size: 30px;\n  font-weight: bold;\n  text-align: center;\n  margin: 20px 0;\n}\n.chajian {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
